// extracted by mini-css-extract-plugin
module.exports = {"selectionActions":"index_selectionActions__zXsKz","tableContainer":"index_tableContainer__2lO6C"};